import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LawFirmHeader from './components/header/LawFirmHeader';
import HomePage from './pages/home/HomePage';
import ContactPage from './pages/contact/Page';
import AboutPage from './pages/about/Page';
import PracticeDetail from './pages/practise/Detail';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <LawFirmHeader />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/practices/:slug" element={<PracticeDetail />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about/:slug" element={<AboutPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
